<template>
  <div class="content-panel">
    <ts-loading-banner :loading="loading">
      <div class="content-header-wrapper">
        <h2 class="page-header title">
          <a
            href="#"
            class="mr-2"
            v-show="parentFolderId"
            @click.prevent="goToParentFolder"
          >
            <i class="fas fa-chevron-left"></i>
          </a>
          {{ folderName ? folderName : $t('fileManager.myFiles') }}
        </h2>
        <div class="actions">
          <b-dropdown variant="success" right no-caret>
            <template #button-content>
              <i class="fa fa-plus"></i> Upload New Item
            </template>
            <b-dropdown-item @click="uploadFile" :disabled="!currentFolderId"
              ><i class="fas fa-file-upload"></i>
              {{ $t('fileManager.uploadFile') }}</b-dropdown-item
            >
            <b-dropdown-item @click="createFolder"
              ><i class="fas fa-folder-plus"></i>
              {{ $t('fileManager.createFolder') }}</b-dropdown-item
            >
            <b-dropdown-item @click="uploadFolder"
              ><i class="fas fa-folder"></i>
              {{ $t('fileManager.uploadFolder') }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
      <div class="content-utilities">
        <div class="page-nav">
          <span class="indicator">View:</span>
          <div class="btn-group" role="group">
            <a
              class="btn btn-default"
              :class="{ active: gridView }"
              data-placement="bottom"
              v-tooltip="'Grid View'"
              @click.prevent="grid"
            >
              <i class="fa fa-th-large"></i>
            </a>
            <a
              class="btn btn-default"
              :class="{ active: listView }"
              data-placement="bottom"
              v-tooltip="'List View'"
              @click.prevent="list"
            >
              <i class="fa fa-list-ul"></i>
            </a>
          </div>
        </div>
        <div class="actions">
          <div class="btn-group">
            <select v-model="item_type" class="form-control btn btn-default">
              <option :value="null">All Items</option>
              <option
                class="text-left"
                v-for="(item, index) in items"
                :key="index"
                :value="item.value"
                >{{ item.text }}</option
              >
            </select>
          </div>
          <div class="btn-group">
            <select
              v-model="direction"
              class="form-control btn btn-default"
              @change="getCurrentFolder"
            >
              <option
                class="text-left"
                v-for="(item, index) in sorting"
                :key="index"
                :value="item.value"
              >
                {{ item.text }}</option
              >
            </select>
          </div>
          <div class="btn-group">
            <search />
          </div>
        </div>
      </div>
      <grid-view
        v-if="gridView == 'active'"
        @fetchCurrentFolder="getCurrentFolder"
        @fetchNav="$emit('fetchNavi')"
        :itemType="item_type"
      />
      <list-view
        v-if="listView == 'active'"
        @fetchCurrentFolder="getCurrentFolder"
        @fetchNav="$emit('fetchNavi')"
        :itemType="item_type"
      />
    </ts-loading-banner>
    <a-modal
      v-model="create_folder_show"
      :title="$t('fileManager.createFolder')"
      @cancel="() => (create_folder_show = false)"
      width="20%"
      :maskClosable="false"
      :footer="null"
      :zIndex="1020"
    >
      <create-folder-component
        :data="{ id: currentFolderId }"
        @close="() => (create_folder_show = false)"
      />
    </a-modal>
  </div>
</template>
<script>
import gridView from './grid-view.vue'
import listView from './list-view.vue'
import { mapState } from 'vuex'
import { isEmpty } from 'lodash'
import CreateFolderComponent from './create-folder.vue'
import UploadFileComponent from './upload-files-popup.vue'
import Search from './search.vue'
export default {
  name: 'contentPanel',
  components: {
    gridView,
    listView,
    CreateFolderComponent,
    Search
  },
  data () {
    return {
      gridView: 'active',
      listView: '',
      loading: false,
      create_folder_show: false,
      item_type: null,
      items: [
        {
          value: 'folder',
          text: 'Folders'
        },
        {
          value: 'file',
          text: 'Documents'
        },
        {
          value: 'media_file',
          text: 'Media Files'
        },
        {
          value: 'image',
          text: 'Images'
        }
      ],
      sorting: [
        {
          value: 'ASC',
          text: 'Newest first'
        },
        {
          value: 'DESC',
          text: 'Oldest first'
        }
      ]
    }
  },
  computed: {
    ...mapState('fileManager/fileBrowser', [
      'entries',
      'currentFolderId',
      'currentFolder'
    ]),
    direction: {
      get () {
        return this.$store.state.fileManager.fileBrowser.direction
      },
      set (newValue) {
        this.$store.commit('fileManager/fileBrowser/SET_DIRECTION', newValue)
      }
    },
    parentFolderId () {
      if (!isEmpty(this.currentFolder)) {
        if (!isEmpty(this.currentFolder.data)) {
          return !isEmpty(this.currentFolder.data.relationships.parent)
            ? this.currentFolder.data.relationships.parent.data.id
            : null
        }
        return null
      }
      return null
    },
    folderName () {
      if (!isEmpty(this.currentFolder)) {
        if (!isEmpty(this.currentFolder.data)) {
          return !isEmpty(this.currentFolder.data.attributes)
            ? this.currentFolder.data.attributes.name
            : null
        }
        return null
      }
      return null
    }
  },
  methods: {
    grid () {
      this.gridView = 'active'
      this.listView = ''
    },
    list () {
      this.listView = 'active'
      this.gridView = ''
    },
    getCurrentFolder () {
      this.loading = true
      this.$store
        .dispatch('fileManager/fileBrowser/getFolder', this.currentFolderId)
        .finally(() => {
          this.loading = false
        })
    },
    goToParentFolder () {
      this.$store.commit(
        'fileManager/fileBrowser/SET_CURRENT_FOLDER_ID',
        this.parentFolderId
      )
      this.$router.push({
        name: 'file-manager-folder',
        params: { id: this.parentFolderId }
      })
    },
    uploadFile () {
      this.$modal.show(
        UploadFileComponent,
        {
          data: {
            id: this.currentFolder.data.id,
            name: this.currentFolder.data.attributes.name
          }
        },
        {
          height: 'auto',
          width: '800px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.getCurrentFolder
        }
      )
    },
    uploadFolder () {
      this.$toasted.info('Under Construction!')
    },
    createFolder () {
      this.create_folder_show = true
    },
    getLabel (item) {
      return item.name
    },
    updateItems (text) {
      console.log(text)
    }
  },
  watch: {
    currentFolderId: function (val) {
      if (val) {
        this.getCurrentFolder()
      }
    }
  }
}
</script>
